export default __webpack_public_path__ + "static/media/tokensale.c52ecf1f.png";